// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","StrollerbaseBanner":"ti_a bib_b bib_bj","StrollerbaseBanner__hint":"ti_b bib_vh","StrollerbaseBanner__link":"ti_c"};